module.exports = __webpack_public_path__ + "static/media/poster.9ea89e2f.jpg";